import { Spinner, styled } from '@volkswagen-onehub/components-core';
import React, { useContext, useEffect, useState } from 'react';
import { Ofertas } from './components/ofertas';
import { OfertasContext } from './context/ofertas-context';
import { getDisclaimers, RegisteredDisclaimer } from './helpers/get-disclaimer';
import { useDisclaimerReference } from './helpers/use-disclaimer-reference';
import { CarlineWithOfertas, filtersFaContentOfertas } from './services/ofertas-service/models/ofertas';
import { setGlobalDisclaimer } from './utils/set-global-disclaimer';

const Content = styled.div`
	padding: 44px 31px;
	flex: auto;
	text-align: center;
	width: 100%;
	margin-top: 10%;

	@media screen and (min-width: 560px) {
		padding: 52px 46px;
	}

	@media screen and (min-width: 960px) {
		padding: var(--size-grid001);
	}
`;

export function Home(): JSX.Element {
	const { disclaimerManager, pageInfoService, breacrumbService, ofertasService, contentService, cmsService } =
		useContext(OfertasContext);

	const [emptyCarlines, setEmptyCarlines] = useState<boolean>(false);
	const [carlines, setCarlines] = useState<CarlineWithOfertas[]>([]);
	const [disclaimers, setDisclaimers] = useState<RegisteredDisclaimer[]>([]);
	const [hasOneCarline, setHasOneCarline] = useState<boolean>(false);
	const [isCallMeNowOpen, setIsCallMeNowOpen] = useState<boolean>(false);

	const filtersFaContentOfertas = contentService?.content as filtersFaContentOfertas;
	const scopedDisclaimerManager = disclaimerManager.getScopedDisclaimerManager();

	useDisclaimerReference(disclaimers);
	setGlobalDisclaimer(scopedDisclaimerManager);

	useEffect(() => {
		breacrumbService.set([]);
		pageInfoService.setPageInfo();
	}, [pageInfoService, breacrumbService]);

	// Carga inicial
	useEffect(() => {
		ofertasService
			.getOfertas(filtersFaContentOfertas)
			.then((carlines) => {
				setCarlines(carlines);
				const currentDisclaimers = getDisclaimers(carlines);

				if (carlines.length === 1) setHasOneCarline(true);
				if (carlines.length === 0) setEmptyCarlines(true);

				setDisclaimers(currentDisclaimers);
			})
			.catch((error) => {
				console.error('Error al obtener las ofertas:', error);
				setEmptyCarlines(true);
			});

		ofertasService
			.getIsCallMeNowOpen()
			.then((isOpen) => {
				setIsCallMeNowOpen(isOpen);
			})
			.catch((error) => {
				console.error('Error al cargar status de Call Me Now:', error);
			});
	}, [filtersFaContentOfertas, ofertasService]);

	return (
		<>
			{cmsService.inEditor ? (
				<h1>Ofertas V2: cmsService.inEditor</h1>
			) : carlines.length > 0 ? (
				<Ofertas hasOneCarline={hasOneCarline} isCallMeNowOpen={isCallMeNowOpen} />
			) : emptyCarlines ? (
				<></>
			) : (
				<Content>
					<Spinner variant="x-large" />
				</Content>
			)}
		</>
	);
}
